// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.jW1lSFY8miZCj1eIw66V {
  display: flex;
  gap: 0.5rem;
}
.jW1lSFY8miZCj1eIw66V.psl8EhBSq3WWBaF6TCSg {
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/componentes/Label/Label.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,WAAA;AACJ;AAAI;EACI,mBAAA;AAER","sourcesContent":[".container{\r\n    display: flex;\r\n    gap: 0.5rem;\r\n    &.desabilitado{\r\n        cursor: not-allowed;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
export var container = `jW1lSFY8miZCj1eIw66V`;
export var desabilitado = `psl8EhBSq3WWBaF6TCSg`;
export default ___CSS_LOADER_EXPORT___;
